import { render, staticRenderFns } from "./congratsComponent.vue?vue&type=template&id=66fc37da&scoped=true&"
import script from "./congratsComponent.vue?vue&type=script&lang=js&"
export * from "./congratsComponent.vue?vue&type=script&lang=js&"
import style0 from "./congratsComponent.vue?vue&type=style&index=0&id=66fc37da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc37da",
  null
  
)

export default component.exports